import { IonRouterOutlet } from "@ionic/react";
import { Redirect, Route, RouteComponentProps } from "react-router";
import { AppRoutes } from "../../constants/appRoutes";
import RequestAddContainer from "./add/container";
import { RequestDetailContainer } from "./detail/container";
import RequestListContainer from "./list/container";
import { AboutSecurityContainer } from "../aboutSecurity/data/container";

export const AppRoute: React.FC<RouteComponentProps> = ({ match }) => {
    return (
        <IonRouterOutlet animated={true}>
            <Route
                exact
                path={AppRoutes.REQUEST}
                component={RequestListContainer}
            />
            <Route
                exact
                path={AppRoutes.REQUEST_DETAILS}
                component={RequestDetailContainer}
            />
            <Route
                exact
                path={AppRoutes.ADD_REQUEST}
                component={RequestAddContainer}
            />
            <Route
                exact
                path={AppRoutes.REQUEST_ABOUT_SECURITY}
                component={AboutSecurityContainer}
            />
            <Route render={() => <Redirect to={match.url} />} />
        </IonRouterOutlet>
    );
};
